<template>
  <button
    type="button"
    class="residency-residents-filter__trigger btn btn-secondary btn-medium"
    aria-label="Фильтр"
    @click="filterOpen = true"
  >
    <FilterIcon :filled="isFilterApplied" />
  </button>

  <ResidencyResidentsFilterDrawer v-model:open="filterOpen" @applied="handleApplied" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import FilterIcon from '@/js/components/icons/FilterIcon.vue';
import ResidencyResidentsFilterDrawer from './ResidencyResidentsFilterDrawer.vue';
import {
  getResidencyResidentsScope,
  hasActiveResidencyResidentsDrawerFilters,
} from './sync-filters';

const filterOpen = ref(false);
const filtersRevision = ref(0);

const isFilterApplied = computed(() => {
  filtersRevision.value;

  return hasActiveResidencyResidentsDrawerFilters(getResidencyResidentsScope());
});

function handleApplied(): void {
  filtersRevision.value += 1;
}
</script>
